import Length from "../../../source/js/shared/models/Geometry/Length";
import AbstractShape from "./../Models/Shapes/AbstractShape";

interface CutoutAttributes {
	cutoutOffsetLeft: number;
	cutoutOffsetBottom: number;
	rotation?: number;
}

/**
 * The Cutout model.
 */
export default class Cutout {
	public readonly shape: string;
	public readonly offsets: Length[];
	public readonly attributes: CutoutAttributes;
	public readonly dimensions: object;
	public readonly modifiers: object;
	public readonly instance: AbstractShape;

	/**
	 * Constructs the model.
	 *
	 * @param {string} shape The shape to cut out.
	 * @param {Object} dimensions The dimensions of the cutout shape.
	 * @param {Object} modifiers The modifiers applied to the shape.
	 * @param {CutoutAttributes} attributes The cutout attributes.
	 * @param {AbstractShape|null} instance The shape instance.
	 */
	constructor( shape: string, dimensions: object, modifiers: object, attributes: CutoutAttributes, instance: AbstractShape = null ) {
		this.shape = shape;
		this.dimensions = dimensions[shape];
		this.modifiers = modifiers;
		this.attributes = attributes;
		this.instance = instance;
		this.offsets = [
			new Length( attributes.cutoutOffsetLeft ),
			new Length( attributes.cutoutOffsetBottom ),
		];
	}

	public getShapeObject(): AbstractShape|null {
		return this.instance;
	}

	getLabelMappings(): Record<string, string> {
		return this.getShapeObject().getLabelMappings();
	}
}
